const breakpoints = {
  xs: "425px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  "2xl": "1440px"
};
export default breakpoints;